// extracted by mini-css-extract-plugin
export default {"link":"GiftReport_link__O4bJ-","no_hover":"GiftReport_no_hover__PHNmy"};